import EditMilestone from './components/EditMilestone';
import { bindActionCreators } from 'redux';
import withRouter from 'react-router/withRouter';
import get from 'lodash/get';
import values from 'lodash/values';
import { connect } from 'react-redux';

import {
  loadMilestones,
  createMilestone,
  updateMilestone
} from '../../shared/redux/entities/actions';
import './EditMilestone.css'
import has from "lodash/has";

function mapStateToProps(state,props){
  const milestoneId = props.match.params.milestoneId;
  return {
    milestoneId:milestoneId,
    needsLoading:!has(state,['entities','milestones',milestoneId,'name']),
    isCreate:milestoneId === 'new',
    milestone:get(state,['entities','milestones',milestoneId], null),
    milestones:values(get(state,['entities','milestones'],{})).filter((m) => (m.milestoneType === 'message' || m.milestoneType === 'feature'))
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    loadMilestones,
    createMilestone,
    updateMilestone
  },dispatch)
}

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(EditMilestone));



// WEBPACK FOOTER //
// ./src/routes/EditMilestone/index.js